import React from 'react'

function EirFieldset(props) {
    const CustomTag = props.priority ? `h${props.priority}` : 'h4';
    return (
        <div className="eir-fieldset">
            <fieldset className={"fieldset-scheduler-border-" + (props.border ? props.border : 'solid')}>
                {props.legend &&
                    <legend className={"legend-scheduler-border"}><CustomTag>{props.legend}</CustomTag></legend>
                }
                {
                    props.legend ? props.children : <div className="fieldset-no-legend">{props.children}</div>
                }

            </fieldset>
        </div>
    )
}

export default EirFieldset;
